<template>

<v-container
    class="spacing-playground py-0 px-2"
    fluid
  >

<v-app-bar
      app
      color="grey lighten-4"
    >
          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>




  </v-app-bar>
  
 <v-row justify="center">
    <v-col cols="12" sm="8">

      <div>
    <v-alert
      v-model="alert"
      type="success"
      border="left"
      close-text="Close Alert"
      dismissible
    >
     Congratulations!  You have successfully registered your student.  Please check your email to finish registration process.
    </v-alert>

  </div>

 

   


  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >


  <form-wizard @on-complete="getBusinessCode"
               @on-loading="setLoading"
               @on-validate="handleValidation"
               @on-error="handleErrorMessage"
               title="ConciergePad Application Form"
               subtitle="Please fill in information.  Please make sure to fill out appropriate fields for each step."
               v-if="registered"
  >
     <tab-content title="Business Code"
                  icon="fas fa-lock"
                  :before-change="validateAsync">
      <v-card
    class="mx-auto"
  >


    <v-list-item-subtitle>Please enter business code provided by school or business.</v-list-item-subtitle>
    <v-text-field
      v-model="businessCode"
      :counter="3"
      :rules="nameRules"
      label="Business Code"
      @keyup="uppercase"
      required
        placeholder="Business Code"
            solo
    ></v-text-field>

     <v-alert type="success" v-model="validCode">
      Business Code is Valid.
    </v-alert>

     <v-alert type="error" v-model="invalidCode">
     Business Code is NOT Valid.
    </v-alert>

    </v-card>
     </tab-content>


     <tab-content title="Parent/Guardian Info"
                  icon="fas fa-user"
                  :before-change="validateAsyncParent">
      
<v-card
    class="mx-auto"
  >
  
    <v-list-item-subtitle>Please enter your Personal Information below.</v-list-item-subtitle>

    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail/Username"
      @keyup="checkEmail"
      required
      outlined
      v-if="registered"
    ></v-text-field>

     <v-alert type="success" v-model="validEmail" v-if="registered">
      Email not registered.
    </v-alert>

     <v-alert type="error" v-model="invalidEmail" v-if="registered">
     Email already registered.
    </v-alert>


    <v-text-field
      v-model="firstName"
      :rules="nameRules"
      label="First Name"
      required
      outlined
      v-if="registered"
    ></v-text-field>

    <v-text-field
      v-model="lastName"
      :rules="nameRules"
      label="Last Name"
      required
      outlined
      v-if="registered"
    ></v-text-field>

      <v-text-field
      v-model="mobileNo"
      :rules="mobileRules"
      v-mask="'##########'"
      type="tel"
      label="Mobile No"
      required
      outlined
      v-if="registered"
    ></v-text-field>


  </v-card>


    </tab-content>


     <!--<tab-content title="Student(s) Info"
                  icon="fas fa-list"
                  :before-change="validateAsyncStudent"
                 >

                  <v-card
    class="mx-auto"
    outlined
  >

  <v-chip
      class="ma-2"
      color="primary"
      text-color="white"
      
    >
      You can only add 4
      <v-icon right>mdi-alert</v-icon>
    </v-chip>

        <v-list-item-subtitle>Add up to 4 students to your profile</v-list-item-subtitle>
    <v-list-item three-line>
      <v-list-item-content>
        <v-text-field
      v-model="studentFirstName"
      label="Student First Name"
      placeholder="Student First Name"
     outlined
    ></v-text-field>

      </v-list-item-content>

 <v-list-item-content>
       <v-text-field
      v-model="studentLastName"
      label="Student Last Name"
      placeholder="Student Last Name"
      outlined
    ></v-text-field>

      </v-list-item-content>

     <v-list-item-content>
      

       <v-text-field
      v-model="studentDob" 
      v-mask="'##/##/####'"
        placeholder="mm/dd/yyyy"
        label="Date of Birth"
           outlined
    ></v-text-field>





      </v-list-item-content>

      <v-list-item-content>
        <v-btn large color="primary" v-on:click='addStudent()'>Add Student</v-btn>
      </v-list-item-content>

    </v-list-item>


  </v-card>






 <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      hide-default-footer
       :search="search"
    
    >


      <template>
        <v-row>
          <v-col
            v-for="item in items"
            :key="item.firstName"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
          

              <v-list>
                  <v-btn v-on:click="removeElement(key)">Remove</v-btn>
                <v-list-item>
                  <v-list-item-content>First Name:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.firstName }}</v-list-item-content>
               
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Last Name:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.lastName }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>DOB:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.dob }}</v-list-item-content>
                </v-list-item>

                  <v-list-item>
                  <v-list-item-content>ID:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.studentId }}</v-list-item-content>
                </v-list-item>

                  <v-list-item>
                  <v-list-item-content>Family ID:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.hangerId }}</v-list-item-content>
                </v-list-item>


              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>


    </v-data-iterator>
 </tab-content>-->
     <!--<tab-content title="Authorized Guardian(s) Info"
                  icon="fas fa-check">
       

         <v-card
    class="mx-auto"
    outlined
  >
       <v-chip
      class="ma-2"
      color="primary"
      text-color="white"

    >
      You can only add 4
      <v-icon right>mdi-alert</v-icon>
    </v-chip>
        <v-list-item-subtitle>Add up to 4 authorized guardians to your profile</v-list-item-subtitle>
    <v-list-item three-line>

    <v-list-item-content>
        <v-text-field
      v-model="guardianFirstName"
      label="First Name"
      outlined
    ></v-text-field>
    </v-list-item-content>

    <v-list-item-content>
       <v-text-field
      v-model="guardianLastName"
      label="Last Name"
      outlined
    ></v-text-field>
    </v-list-item-content>

   <v-list-item-content>
       <v-text-field
      v-model="guardianRelation"
      label="Relationship to Student"
      outlined
    ></v-text-field>
    </v-list-item-content>

    <v-list-item-content>
       <v-text-field
      v-model="guardianEmail"
      :rules="emailRules"
      label="Email"
      @keyup="checkEmailGuardian"
      outlined
    ></v-text-field>

     <v-alert type="success" v-model="validEmailGuardian">
      {{alreadyRegistered}}
    </v-alert>

     <v-alert type="error" v-model="invalidEmailGuardian">
     {{alreadyRegistered}}
    </v-alert>
    </v-list-item-content>

    <v-list-item-content>
       <v-text-field
      v-model="guardianPhone"
      label="Mobile No"
      v-mask="'##########'"
      type="tel"
      outlined
    ></v-text-field>
    </v-list-item-content>

      <v-list-item-content>
        <v-btn large color="primary" v-on:click='addAuthParent()'>Add Guardian</v-btn>
      </v-list-item-content>

    </v-list-item>


  </v-card>






 <v-data-iterator
      :items="guardianItems"
      :items-per-page.sync="guardianItemsPerPage"
      hide-default-footer
    
    >


       <template>
        <v-row>
          <v-col
            v-for="item in guardianItems"
            :key="item.guardianFirstName"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
          

              <v-list>
                  <v-btn v-on:click="removeElementGuardian(key)">Remove</v-btn>
                <v-list-item>
                  <v-list-item-content>First Name:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.guardianFirstName }}</v-list-item-content>
               
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Last Name:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.guardianLastName }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Relation:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.guardianRelation }}</v-list-item-content>
                </v-list-item>

                  <v-list-item>
                  <v-list-item-content>Email:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.guardianEmail }}</v-list-item-content>
                </v-list-item>

                  <v-list-item>
                  <v-list-item-content>Mobile:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.guardianPhone }}</v-list-item-content>
                </v-list-item>




              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>


    </v-data-iterator>


     </tab-content>-->
 </form-wizard>

 

 




  



  </v-form>


    </v-col>
 </v-row>




</v-container>
</template>

<script>
// @ is an alias to /src

import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css'
import { uuid } from 'vue-uuid';
import moment from 'moment-timezone';



export default {
  

    data: () => ({
  uuid: uuid.v1(),
  registrationUuid: uuid.v1(),
  registered: true,
  loadingWizard: false,
  errorMsg: null,
  count: 0,
  validCode: false,
  invalidCode: false,
  validEmail: false,
  invalidEmail: false,
  validEmailGuardian: false,
  invalidEmailGuardian: false,
  alreadyRegistered: '',
  alert: false,
  search: '',
  fromDateMenu: true,
  fromDateVal: null,
  hangerId: '',
  minDate: "1900-07-04",
  maxDate: "2019-08-30",
  itemsPerPage: 4,
  guardianItemsPerPage: 4,
  items: [],
  guardianItems: [],
  studentFirstName: '',
  studentLastName: '',
  studentDob: null,
  guardianFirstName: '',
  guardianLastName: '',
  guardianRelation: '',
  guardianEmail: '',
  guardianPhone: '',
  valid: true,
  businessCode: '',
  firstName: '',
  lastName: '',
  email: '',
  mobileNo: '',
  students: {},
  dob: new Date(),

      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 20) || 'Name must be less than 10 characters',
      ],
      mobileRules: [
        v => !!v || 'Mobile is required',
        v => (v && v.length == 10) || 'Mobile format is not correct',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      checkbox: false,
    }),

    mounted: function() {
      
      //this.hangerId = Math.floor(Math.random()*90000) + 10000;


      this.hangerId = this.uuid;

      console.log(this.registrationUuid);

      this.$intercom.boot({
          app_id: "naxtoq3z"
        });
      this.$intercom.show();

   
    },

    computed: {

    

  
      fromDateDisp() {
        return this.fromDateVal;
        // format date, apply validations, etc. Example below.
        // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
      }

    },

    methods: {

      setLoading: function(value) {
            this.loadingWizard = value
        },
      handleValidation: function(isValid, tabIndex){
           console.log('Tab: '+tabIndex+ ' valid: '+isValid)
        },
        handleErrorMessage: function(errorMsg){
          this.errorMsg = errorMsg
        },
        validateAsync:function() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              if(this.validCode == true){
               
                    resolve(true)
                  
              }else{

                reject('This is a custom validation error message. Click next again to get rid of the validation')
              
          
              }   
            }, 1000)
          })
         },
         validateAsyncParent:function() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {

                console.log(this.firstName.length);
                console.log(this.lastName.length);
                console.log(this.email.length);
                console.log(this.mobileNo.length);

              if(this.firstName.length == 0 || this.lastName.length == 0 || this.email.length == 0 || this.mobileNo.length == 0){

               
               
                   console.log("In validataion rejection");

                reject('This is a custom validation error message. Click next again to get rid of the validation')
              }

            else if(this.invalidEmail == true){

                reject('This is a custom validation error message. Click next again to get rid of the validation')

                  
              } else{

                  console.log("In validataion");

                  resolve(true)
                 
              
          
              }   
            }, 1000)
          })
         },
          validateAsyncStudent:function() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {

              if(this.items.length == 0){

                console.log("In validataion rejection");

                reject('This is a custom validation error message. Click next again to get rid of the validation')
                  
              }else{

                  console.log("In validataion");

                  resolve(true)

              }   
            }, 1000)
          })
         },
       addStudent: function() {

         if (this.studentFirstName.length == 0 || this.studentFirstName.length == 0 || this.fromDateVal == 0) {

            console.log("No Students");

         } else {

        var student_id = Math.floor(Math.random()*90000) + 10000;

        this.items.push({firstName: this.studentFirstName, lastName: this.studentLastName , studentId: student_id, dob: this.studentDob, hangerId: this.hangerId}); // what to push unto the rows array?
        console.log(this.items);

        this.studentFirstName = '';
        this.studentLastName = '';
        this.studentDob = '';


        }

      },
       addAuthParent: function() {

          if (this.guardianFirstName.length == 0 || this.guardianLastName.length == 0 || this.guardianRelation == 0 || this.guardianEmail == 0 || this.guardianPhone == 0) {

            console.log("No Students");

         } 
         else if (this.invalidEmailGuardian == true) {

            console.log("Email already exists");
         }
         else {

        var guardian_id = Math.floor(Math.random()*90000) + 10000;

        this.guardianItems.push({guardianFirstName: this.guardianFirstName, guardianLastName: this.guardianLastName , guardianId: guardian_id, guardianRelation: this.guardianRelation, guardianEmail: this.guardianEmail, guardianPhone: this.guardianPhone}); // what to push unto the rows array?
        console.log(this.guardianItems);

        this.guardianFirstName = null;
        this.guardianLastName = null;
        this.guardianRelation = null;
        this.guardianEmail = null;
        this.guardianPhone = null;

         }

      },

       uppercase() {
        this.businessCode = this.businessCode.toUpperCase();

        if (this.businessCode.length == 3) {

          this.getBusinessCodeCheck();

        } else {

          this.invalidCode = true;
          this.validCode = false;
        }
    },
    checkEmailGuardian() {

       if (this.guardianEmail == this.email) {

         this.validEmailGuardian = false;
         this.invalidEmailGuardian = true;
         this.alreadyRegistered = "Already registered as Guardian.  Don't have to input yourself."

       } else {

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = ""

        this.checkGuardian();

       }


    },
    checkGuardian:function() {

      axios.get('https://api.conciergepadedu.com/api/Users/CheckUser/' +  this.guardianEmail).then(response => {

      if (response.data.error) {

         console.log("ERROR");

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = "Email not registered"

      } else {

        console.log(response.data);

        //successful
        this.validEmailGuardian = false;
        this.invalidEmailGuardian = true;
        this.alreadyRegistered = "Email already registered"

        }

        }).catch(error => {

            console.log(error.response)

            this.validEmailGuardian = true;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "Email not registered"

            if (this.guardianEmail.length == 0) {

            this.validEmailGuardian = false;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "";

            }

        });

    },
     checkEmail() {

      
     

          this.getEmail();

      
    },

 uploadUserToApi(email,companyName,guid,mobilePhone,firstName,lastName,dob,hangerId,regUuid) {

  //note:auth will be 3rd parameter in post request
  axios.post('https://api.conciergepadedu.com/api/Users/PostUser',{ 
         USERNAME: email,
         PASSWORD: '',
         EMAIL: email,
         COMPANY_NAME: companyName,
         UUID: guid,
         MOBILE_PHONE: mobilePhone,
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         DOB: dob,
         DATE_CREATED: dob,
         HANGER_ID: hangerId,
         REGISTRATION_UUID:regUuid,
         PRIMARY_ACCOUNT: 'Y'
      }).then(response => {

      if (response.data.error) {

          console.log('error', response.data.error);

      } else {

        console.log('success', response.data)
        /*var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");
          console.log(newDate);

          this.$intercom.boot({
          user_id: email,
          name: firstName + ' ' + lastName,
          email: email
        });
        this.$intercom.show();
        this.$intercom.showNewMessage("Okay, almost done.  Please go to your email to finish registration.");*/
      }

     }).catch(error => {

        console.log(error.response)

      });

   
    },

  uploadStudentToApi(grade,lastName,firstName,studentId,companyName,birthday,hangerId,loadDate) {

  axios.post('https://api.conciergepadedu.com/api/Rosters/PostRoster',{ 
         GRADE: grade,
         LAST_NAME: lastName,
         FIRST_NAME: firstName,
         STUDENT_ID: studentId,
         COMPANY_NAME: companyName,
         BIRTHDAY: birthday,
         LOAD_DATE: loadDate,
         HOMEROOM: 'ALL',
         HANGER_ID: hangerId
      }).then(response => {


      if (response.data.error) {

        console.log('error', response.data.error);

      } else {

        console.log('success', response.data)
      }

     }).catch(error => {

        console.log(error.response)

      });

   
    },

  uploadParentToApi(firstName,lastName,dob,companyName,studentId,studentRelation,hangerId, authEmail) {

  axios.post('https://api.conciergepadedu.com/api/Parents/PostParent',{ 
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         DOB: dob,
         COMPANY_NAME: companyName,
         AUTH_TYPE: 'Y',
         STUDENT_ID: studentId,
         DATE_ADDED: new Date(),
         STUDENT_RELATION: studentRelation,
         HANGER_ID: hangerId,
         AUTH_EMAIL: authEmail,
         ACTIVATE_FLAG: 'Y'
      }).then(response => {


      if (response.data.error) {

        console.log('error', response.data.error)

      } else {

        console.log('success', response.data)
      }

     }).catch(error => {

        console.log(error.response)

      });

   
    },
    getBusinessCodeCheck:function() {

      axios.get('https://api.conciergepadedu.com/api/Codes/' +  this.businessCode).then(response => {

      if (response.data.error) {

        this.validCode = false;
        this.invalidCode = true;

      } else {

        console.log(response.data);

        //successful
        this.validCode = true;
        this.invalidCode = false;


        }

        }).catch(error => {

            console.log(error.response)

            this.validCode = false;
            this.invalidCode = true;

        });

    },
    getEmail:function() {

      axios.get('https://api.conciergepadedu.com/api/Users/CheckUser/' +  this.email).then(response => {

      if (response.data.error) {

         console.log("ERROR");

        this.validEmail = true;
        this.invalidEmail = false;

      } else {

        console.log(response.data);

        //successful
        this.validEmail = false;
        this.invalidEmail = true;


        }

        }).catch(error => {

            console.log(error.response)

            this.validEmail = true;
            this.invalidEmail = false;

        });

    },
    getBusinessCode:function() {



    if ((this.email.includes('@') == false) && (this.email.includes('.') == false)) {


      this.email = '';
      this.$alert("Registration.  Email not correct","Add","error");

    }

    else if (this.mobileNo.length < 10) {


      this.mobileNo = '';
      this.$alert("Registration.  Mobile Phone Not Correct","Add","error");

    }

    else if (this.alert == false) {

      axios.get('https://api.conciergepadedu.com/api/Codes/' +  this.businessCode).then(response => {

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

      } else {

        console.log(response.data);

        this.businessCode = '';

        //successful
        var compName = response.data.companY_NAME;

        var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");

        //do main applicant
        this.uploadUserToApi(this.email,compName,this.uuid,this.mobileNo,this.firstName.replace("á","a").replace("ó","").replace("ñ","n").replace("í","i").replace("é","e").replace("'",""),this.lastName.replace("á","a").replace("ó","").replace("ñ","n").replace("í","i").replace("é","e").replace("'",""),newDate,this.hangerId,this.registrationUuid)

            this.alert = true;

            this.businessCode = '';
            this.email = '';
            this.firstName = '';
            this.lastName = '';
            this.mobileNo = '';
            this.items = [];
            this.guardianItems = [];

            this.registered = false;

            this.$alert("We've received the data. Please check your email to complete the registration process.","Registration","success");

            

        }

        }).catch(error => {

            console.log(error.response)

        });

       }

    },

      removeElement: function (index) {
        this.items.splice(index, 1);
      },
      removeElementGuardian: function (index) {
        this.guardianItems.splice(index, 1);
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  name: 'Home',
  components: {


  }
}
</script>

<style>
  .spacing-playground .v-select .v-input__prepend-outer, .spacing-playground .v-select .v-input__append-outer{
    margin-top: 0.55rem;
    margin-right: 0.2rem;
  }
</style>